// extracted by mini-css-extract-plugin
module.exports = {"outerBox":"RecipeDetails_outerBox__1LpXG","detailsContainer":"RecipeDetails_detailsContainer__d8Flq"};